import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { Chart, ChartConfiguration, ChartDataset, ChartOptions } from 'chart.js/auto';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('lineChartCanvas') LineChartCanvas!: ElementRef<HTMLCanvasElement>;

  @Input() labels: string[] = [];
  @Input() datasets: ChartDataset<'line'>[] = [];
  @Input() options: ChartOptions<'line'> = {};
  public lineChart: Chart<'line'> | null = null;

  constructor() {}

  ngAfterViewInit() {
    this.renderChart();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (!this.LineChartCanvas) {
      return;
    }

    if (changes.labels || changes.datasets || changes.options) {
      this.renderChart();
    }
  }

  ngOnDestroy() {
    if (this.lineChart) {
      this.lineChart.destroy();
    }
  }
  private renderChart(): void {
    const labels = this.labels;
    const datasets = this.datasets;

    if (!labels.length || !datasets.length) {
      if (this.lineChart) {
        this.lineChart.destroy();
        this.lineChart = null;
      }
      return;
    }
    const config: ChartConfiguration<'line'> = {
      type: 'line',
      data: {
        labels,
        datasets: datasets.map((dataset) => ({
          ...dataset,
          tension: 0.1,
        })),
      },
      options: {
        ...this.options,
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
        },
      },
    };

    if (this.lineChart) {
      this.lineChart.destroy();
    }
    this.lineChart = new Chart(this.LineChartCanvas.nativeElement, config);
  }
}
